<div class="footer">
  <div class="footer1">
    <ul class="inner-wrap clearfix">
      <li><a routerLink="/contents" [queryParams]="{menu_seq: '503'}">{{'MENU.MENU503' | translate}}</a></li>
      <li><a routerLink="/contents" [queryParams]="{menu_seq: '506'}">{{'MENU.MENU506' | translate}}</a></li>
      <li><a routerLink="/contents" [queryParams]="{menu_seq: '508'}">{{'MENU.MENU508' | translate}}</a></li>
    </ul>
  </div>
  <div class="footer2 inner-wrap clearfix">
    <div class="logo">
      <a routerLink="/main" class="footer-logo">
        <img src="/assets/images/logo_footer.png" alt="{{'MAIN.LOGO' | translate}}" />
        <img src="/assets/images/logo_footer1.png" alt="{{'MAIN.LOGO' | translate}}" />
      </a>
    </div>
    <div class="com-info">
      <div class="address" [innerHTML]="'FOOTER.ADDRESS' | translate"></div>
      <div class="copyright" [innerHTML]="'FOOTER.COPYRIGHT' | translate"></div>
    </div>
  </div>
</div>